import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import ContactCreationFormWrapper from '../../Forms/Contact/ContactCreationFormWrapper/ContactCreationFormWrapper.component';

import styles from './CreateContactDrawer.module.scss';

const CreateContactDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('contacts.addContact', 'Ajouter un contact')}
      to={`/asset/${assetId}/contacts`}
    >
      {({ onClose }) => (
        <div className={styles.content}>
          <ContactCreationFormWrapper onCreate={onClose} onCancel={onClose} />
        </div>
      )}
    </AnimatedRoutedDrawer>
  );
};

export default CreateContactDrawer;
